import Tooltip from 'rc-tooltip';

import { PersonContactData } from '../../types/TymbeApi';
import { verified, alert } from '../../utils/colors';
import { PhoneIcon } from '@tymbe/ty-components/icons';

export interface PhoneVerificationBadgeProps {
  contact?: PersonContactData;
  size?: number;
}

const PhoneVerificationBadge = ({ contact, size = 16 }: PhoneVerificationBadgeProps) => {
  if (!contact) return null;

  const isVerified = !!contact.verified_at;

  return (
    <Tooltip
      placement="right"
      trigger={['hover']}
      overlay={isVerified ? 'Ověřené telefonní číslo' : 'Neověřené telefonní číslo'}
    >
      <div>
        <PhoneIcon fill={isVerified ? verified : alert} width={size} height={size} />
      </div>
    </Tooltip>
  );
};

export default PhoneVerificationBadge;
